import { render, staticRenderFns } from "./orderiklandigitalfrm.vue?vue&type=template&id=6d32c898"
import script from "./orderiklandigitalfrm.vue?vue&type=script&lang=js"
export * from "./orderiklandigitalfrm.vue?vue&type=script&lang=js"
import style0 from "./orderiklandigitalfrm.vue?vue&type=style&index=0&id=6d32c898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports